import { IRefIds } from 'constants/refs';
import { get, post } from 'services/request';
import { BaseModel, IModelOptions } from './BaseModel';
import { IItemSourceMeanValidatorItem } from 'types/itemSourceMeanValidator';
import { IModelUpdateRowTypes } from '../types/models';

export default class ItemSourceMeanValidatorItemsModel extends BaseModel<IItemSourceMeanValidatorItem, null> {
  jobId?: number;

  constructor(options: IModelOptions & { jobId?: number }) {
    super(options);
    this.jobId = options.jobId;
    this.ref = IRefIds.itemSourceMeanValidator;
    this.gridName = 'ItemSourceMeanValidatorItems';
    this.getGridColumns();
  }

  setJobId(jobId: number) {
    this.jobId = jobId;
    this.gridData = [];
    this.getGrid();
  }

  async getGrid() {
    if (!this.jobId) return;

    await super.getGrid();
    this.gridData = await get<IItemSourceMeanValidatorItem[]>(`item-source-mean-validator/${this.jobId}/items`);
    this.loadingGrid = false;
    this.render();
  }

  async keepItem(itemId: number) {
    const response = await post<{
      success: boolean;
      message: string;
      item_id: number;
      status: number;
      decision: string;
    }>(`item-source-mean-validator/items/${itemId}/keep`, {});

    if (response.data) {
      await this.updateGridRow(itemId, 'update');
    }

    return response;
  }

  async changeItem(itemId: number) {
    const response = await post<{
      success: boolean;
      message: string;
      item_id: number;
      status: number;
      decision: string;
    }>(`item-source-mean-validator/items/${itemId}/change`, {});

    if (response.data) {
      await this.updateGridRow(itemId, 'update');
    }

    return response;
  }


  async refresh() {
    await this.getGrid();
  }

  async reload() {
    await super.reload();
    await this.getGrid();
  }

  async loadItemData(itemId: number) {
    return {};
  }

  async getGridRow(itemId: number) {
    return await get<IItemSourceMeanValidatorItem>(`item-source-mean-validator/items/${itemId}`);
  }

  async updateGridRow(itemId: number, type: IModelUpdateRowTypes = 'update') {
    await super.updateGridRow(itemId, type);
    if (type === 'update' && this.gridDataUpdateRow?.data && Array.isArray(this.gridData)) {
      const index = this.gridData.findIndex((item) => item.id === itemId);
      if (index !== -1) {
        this.gridData[index] = this.gridDataUpdateRow.data as IItemSourceMeanValidatorItem;
        this.gridData = [...this.gridData];
        this.render();
      }
    } else if (type === 'remove' && Array.isArray(this.gridData)) {
      this.gridData = this.gridData.filter((item) => item.id !== itemId);
    }
  }

  async bulkChange() {
    this.loadingGrid = true;
    this.render();
    const response = await post<{
      success: boolean;
      message: string;
      processed: number;
      errors: Array<{ item_id: number; error: string }>;
    }>(`item-source-mean-validator/${this.jobId}/bulk-change`, {});

    if (response.data) {
      await this.getGrid();
    }

    this.loadingGrid = false;
    this.render();
    return response;
  }

  async bulkKeep() {
    this.loadingGrid = true;
    this.render();
    const response = await post<{
      success: boolean;
      message: string;
      processed: number;
      errors: Array<{ item_id: number; error: string }>;
    }>(`item-source-mean-validator/${this.jobId}/bulk-keep`, {});

    if (response.data) {
      await this.getGrid();
    }

    this.loadingGrid = false;
    this.render();
    return response;
  }

}
